























import { Vue } from 'vue-property-decorator';
import HellospokeAccount  from '../adminSidebar.vue';

export default Vue.extend({
	name: 'SidebarRow',
	props: {
		account: {
			type: Object as () => HellospokeAccount
		},
		selected_id: {
			type: String
		}
	},
	computed: {
		isSelected: function() {
			if (!this.$props.account || !this.$props.account.id) {
				return false;
			}
			return this.$props.selected_id === this.$props.account.id;
		}
	},
	methods: {
		//If a child is selected propagates the event up to reach the Admin component
		propagateID(data) {
			//alert(id + '555')
			var id=data.id;
			//this.$emit('idSelected', id);  
			//alert(id);
			this.$store.commit('SET_SELECTED_ADMIN_NAME',data.name);
			this.$emit('idSelected', {id:id,name:data.name});
			// this.$store.commit('SET_SELECTED_ADMIN_ID', {
			// 	selectedAccount: id
			// });
		}
	}
})
